import React, { useEffect, useState } from "react";
import { AnalyticsIco, ReloadIco } from "../../../../../modules/CustomIcons";
import { Button, Spin, Dropdown, Menu } from "antd";
import { KeyboardArrowDown } from "@mui/icons-material";
import { dateFormatter, financial } from "../../../../services/helper";
import {Balance, getBalance} from "../../../../services/account";
import { getCurrentCompany } from "../../../../services/user";
import { Spinner } from "constants/constants";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { useActions } from "hooks/useActions";
import { setBalanceLoading } from '../../../../store/actions/accountStatement';
import { useTranslation } from "react-i18next";



const BalanceComponent: React.FC<any> = ({ companyData, loading, accountLoading, transferWidgetLoading }) => {
    const {t} = useTranslation();

    const balance_types = [
        {
            label: t("home.balance"),
            key: 'BALANCE',
            active: true
        },
        {
            label: t("home.blocked"),
            key: 'BLOCK_BALANCE',
            active: false
        },
        {
            label: t("home.availableBalance"),
            key: 'AVAIL_BALANCE',
            active: false
        },
        {
            label: t("home.executionOnBank"),
            key: 'WAITING_BALANCE',
            active: false
        },
        {
            label: t("home.afterExecution"),
            key: 'AFTERAPPROVE_BALANCE',
            active: false
        }
    ];

    const [tableData, setTableData] = useState<Balance[]>();
    const [tableLoading, setTableLoading] = useState(Spinner);
    const [filterDateTime, setFilterDateTime] = useState(dateFormatter());
    const [totalAzn, setTotalAzn] = useState<number>(0);
    const [balanceTypes, setBalanceTypes] = useState<any[]>(balance_types);
    const [selectedType, setSelectedType] = useState<any>(balance_types.find(row => row.active));

    const lang = localStorage.getItem("i18nextLng")

    const { setBalanceLoading } = useActions();

    useEffect(()=>{
        setSelectedType(balance_types.find(row => row.active))
    },[lang])

    const dropDownMenus = (
        <Menu style={{ width: 195 }} className='has_hover_dropdown header-dropdown-menu balance_drop_down' >
            {
                balance_types.map(row => {
                    return (
                        <Menu.Item onClick={() => { setIsBalanceDropdown(false) }}>
                            <Link to={'/'} className={'flex align_center justify_between'} onClick={() => { updateSelectedType(row); return false; }} >
                                <span>{row.label}</span>
                            </Link>
                        </Menu.Item>
                    )
                })
            }
        </Menu>
    )

    const updateSelectedType = (selectedRow:any) => {
        const newBalanceTypes = balance_types.map(row => {
            return {
                ...row,
                active: row.key === selectedRow.key
            }
        });

        setBalanceTypes(old_data => newBalanceTypes);
        setSelectedType(old_data => newBalanceTypes.find(row => row.active));
    }


    const updateLoading = () => setBalanceLoading(true);

    const fetchData = async () => {

        setTableLoading({
            ...tableLoading,
            spinning: true
        });
        const data = await getBalance(getCurrentCompany());

        let temp_array: any = [];
        let total_azn: number = 0;

        for (let row of data) {
            let balance = 0;

            if (selectedType.key === 'BALANCE') {
                balance = row.BALANCE;
                total_azn += parseFloat(row.BALANCE_LC);

            } else if (selectedType.key === 'BLOCK_BALANCE') {
                balance = row.BLOCK_BALANCE;
                total_azn += parseFloat(row.BLOCK_BALANCE_LC);

            } else if (selectedType.key === 'AVAIL_BALANCE') {
                balance = row.AVAIL_BALANCE;
                total_azn += parseFloat(row.AVAIL_BALANCE_LC);

            } else if (selectedType.key === 'WAITING_BALANCE') {
                balance = row.WAITING_BALANCE;
                total_azn += parseFloat(row.WAITING_BALANCE_LC);

            } else if (selectedType.key === 'AFTERAPPROVE_BALANCE') {
                balance = row.AFTERAPPROVE_BALANCE;
                total_azn += parseFloat(row.AFTERAPPROVE_BALANCE_LC);

            }


            temp_array.push({
                currency: row.CCY_NAME,
                balance: parseFloat(balance),
            });

        }


        setTableData(old_data => temp_array);
        setFilterDateTime(old_date => dateFormatter())
        setTotalAzn(old_date => financial(total_azn));

        setTableLoading({
            ...tableLoading,
            spinning: false
        });

        setBalanceLoading(false)
    };


    useEffect(() => {
        if (!loading && !accountLoading && !transferWidgetLoading ) {
            fetchData();
        }

    }, [balanceTypes, loading, accountLoading, transferWidgetLoading]);

    const [isBalanceDropdown, setIsBalanceDropdown] = useState(false);

    const DropDownVisibleChange = () => {
        setIsBalanceDropdown(!isBalanceDropdown)
    }

    const controlDropdownMenu = () => {
        setIsBalanceDropdown(false)
    };

    useEffect(() => {
        const layoutScroll = document.getElementById("layout_scroll");
        if (typeof layoutScroll !== 'undefined') {
            layoutScroll?.addEventListener('scroll', controlDropdownMenu);

            return () => {
                layoutScroll?.removeEventListener('scroll', controlDropdownMenu);
            };
        }
    });


    return (
        <>
            <div className='right_side_box full'>

                <div className='full right_side_box_title flex justify_between'>

                    <div className='flex right_side_box_title_left'>
                        <AnalyticsIco />


                        <div className='flex direction_column right_side_box_title_left_title'>
                            <Dropdown overlay={dropDownMenus} trigger={['click']} className={'has_hover_dropdown'} placement="bottomLeft" visible={isBalanceDropdown} onVisibleChange={() => DropDownVisibleChange()}>
                                <h5 className='flex'>{t("home.commonBalanceWidget")} <span>{selectedType.label}</span>
                                    <Button icon={<KeyboardArrowDown />} className='transparent box_arrow_btn' />
                                </h5>
                            </Dropdown>
                            <p>{filterDateTime}</p>
                        </div>
                    </div>

                    <Button icon={<ReloadIco />} onClick={() => {
                        fetchData();
                        updateLoading();
                    }} className='transparent box_reload_ico' />

                </div>

                <div className='full right_side_box_content'>

                    <Spin{...tableLoading}>

                        {
                            tableData && <ul className='full flex direction_column box_list'>

                                {
                                    tableData?.map((row, index) => {
                                        return (
                                            <li key={`li_${index}`} >
                                                <p>{row.currency}</p>
                                                <p>{financial(row.balance)}</p>
                                            </li>
                                        )
                                    })
                                }

                                <li className='show_total'>
                                    <p>{t("home.totalAZN")}</p>
                                    <p>{totalAzn}</p>
                                </li>
                            </ul>
                        }

                    </Spin>

                </div>

            </div>
        </>
    )
}

const mapDispatchToProps = { setBalanceLoading }

const mapStateToProps = (state: any) => ({
    companyData: (state.user && state.user.companyData.result) ? state.user.companyData.result.customerNo : getCurrentCompany(),
    loading: state.user.isCompChange,
    accountLoading: state.accountsStatement.accountLoading,
    transferWidgetLoading: state.accountsStatement.transferWidgetLoading,
})

export default connect(mapStateToProps, mapDispatchToProps)(BalanceComponent)
